import React from 'react'

import { withRouter, Link } from 'react-router-dom'

import { Container, Icon, Message, Tab } from 'semantic-ui-react';

import {
  PaneInformations,
  PaneActivity,
  PaneLogbook
} from './panes';

import { BreadcrumbHelper, Functions, Typeof } from 'utils';

import './style.css';

class SensorScene extends React.Component {

  constructor(props) {
    super(props);

    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleModelChange = this.handleModelChange.bind(this);
    this.handleDissociate = this.handleDissociate.bind(this);

    let panes = [];

    //Pane informations
    panes.push({
      menuItem: {
        content: 'Informations',
        icon: 'info'
      },
      render: () => {

        const { sensor } = this.state;

        return <PaneInformations sensor={sensor} onDissociate={this.handleDissociate} onModelChange={this.handleModelChange} />
      }
    });

    //Pane logbook
    panes.push({
      menuItem: {
        content: 'Journal de bord',
        icon: 'book'
      },
      render: () => {

        const { sensor } = this.state;

        return <PaneLogbook sensor={sensor} />
      }
    });

    //Pane activity
    panes.push({
      menuItem: {
        content: 'Activité',
        icon: 'feed'
      },
      render: () => {

        const { sensor } = this.state;

        return <PaneActivity sensor={sensor} />
      }
    });


    //Select active tab based on hash
    let hash = window.location.hash.trim().substring(1);
    let activeIndex = hash.length > 0 ? null : 0;

    if (!activeIndex) {

      for(let i = 0; i < panes.length; i++) {

        if(panes[i].id === hash) {
          activeIndex = i;
          break;
        }
      }

      //Unknown hash
      if(!activeIndex) {
        activeIndex = 0;
        window.location.hash = '';
      }
    }

    const { sensor } = this.props;

    this.state = {
      sensor: sensor,
      panes: panes,
      activeIndex: activeIndex
    };

    this.updateBreadcrumb();
  }

  updateBreadcrumb() {

    const { sensor } = this.props;

    //Update breadcrumb
    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Capteurs', '/sensors');
    BreadcrumbHelper.push(Functions.formatMacAddress(sensor.mac_address));

    //Active pane
    let pane = this.state.panes[this.state.activeIndex];
    BreadcrumbHelper.push(pane.menuItem.content);

    BreadcrumbHelper.flush();
  }

  handleModelChange(update) {

    let sensor = { ...this.state.sensor, ...update }

    this.setState({
      sensor: sensor
    }, this.updateBreadcrumb);
  }

  handleDissociate() {

    let sensor = this.state.sensor;
    delete sensor.device;

    this.setState({
      sensor: sensor
    });
  }

  handleTabChange(e, { activeIndex }) {

    this.setState({ activeIndex }, this.updateBreadcrumb);

    //Update location hash
    let pane = this.state.panes[activeIndex];
    window.location.hash = pane.id ?? '';
  }

  render() {

    const { panes, activeIndex, sensor } = this.state;

    let hasDevice = Typeof.number(sensor.device);

    return (
      <React.Fragment>

        <Container>

          {/* No device warning */}
          {!hasDevice &&
            <Message warning>
              <Icon name='warning sign' />
              Ce capteur n'est associé à aucune <Link to="/devices">valise</Link>
            </Message>
          }

          <Tab
            id="tabs"
            panes={panes}
            activeIndex={activeIndex}
            menu={{ secondary: false, pointing: true }}
            onTabChange={this.handleTabChange} />
        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(SensorScene);
